/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the TermsStatusDto interface.
 */
export function instanceOfTermsStatusDto(value) {
    let isInstance = true;
    return isInstance;
}
export function TermsStatusDtoFromJSON(json) {
    return TermsStatusDtoFromJSONTyped(json, false);
}
export function TermsStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currentVersion': !exists(json, 'currentVersion') ? undefined : json['currentVersion'],
        'acceptedVersion': !exists(json, 'acceptedVersion') ? undefined : json['acceptedVersion'],
        'acceptedAt': !exists(json, 'acceptedAt') ? undefined : (json['acceptedAt'] === null ? null : new Date(json['acceptedAt'])),
        'updateRequired': !exists(json, 'updateRequired') ? undefined : json['updateRequired'],
    };
}
export function TermsStatusDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currentVersion': value.currentVersion,
        'acceptedVersion': value.acceptedVersion,
        'acceptedAt': value.acceptedAt === undefined ? undefined : (value.acceptedAt === null ? null : value.acceptedAt.toISOString()),
        'updateRequired': value.updateRequired,
    };
}
